import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";


const useFormUploadLicenses = () => {
  const { token } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  

  const handleSubmit = async (e, formData, onSuccess) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("dpr", formData.dpr);
      formDataToSend.append("nimasa", formData.nimasa);
      formDataToSend.append("npa", formData.npa);

      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/upload/licenses`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const resData = await res.json();

      if (!res.ok) {
        throw new Error(resData.message);
      }

      setLoading(false);
      setSuccess("Licenses uploaded successfully");
     // Trigger the success callback
     if (onSuccess) {
      onSuccess();
    }
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    loading,
    error,
    success
  };
};

export default useFormUploadLicenses;
